var __jsx = React.createElement;
import React, { createContext, useContext } from "react";
var SharedFormDataContext = /*#__PURE__*/createContext(undefined);
export var useSharedFormData = function useSharedFormData() {
  var context = useContext(SharedFormDataContext);
  if (!context) {
    throw new Error("useSharedFormData must be used within SharedFormDataProvider");
  }
  return context;
};
export var SharedFormDataProvider = function SharedFormDataProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(SharedFormDataContext.Provider, {
    value: value
  }, children);
};